<div class="text-center" style="width: 100%">
<i style="font-size: 100px;margin: 20px" class="mdi mdi-check-circle-outline"></i>
  <h1 style="margin: 20px"> REGISTRATION SUCCESSFUL</h1>
  <p style="margin: 20px">SMS has been sent to the user</p>
  <p style="border: 1px solid; width: 41%;margin: 0 auto; padding: 30px">Dear {{visitor.first_name}}, your date and time slot for Mahakal {{visitor?.darshan_type?.name}} is:
    {{visitor.date_of_visit | date : 'dd-MM-yyyy'}} at {{visitor.time_of_visit}}.</p>

  <button style="margin-top: 50px;" class="btn btn-primary btn-fw" routerLink="/registration-list"><i style="font-size: 12px;" class="mdi mdi-arrow-left"></i>Back</button>
</div>
